import { ratio } from '@opendevtools/wcag-color';

export function isWhiteText(bgColor) {
    try {
        return ratio('#FFFFFF', bgColor) > 1.75;
    } catch (e) {
        return false;
    }
}
